import React from 'react';
import styles from './SuggestionItem.module.scss';

interface Props {
  option: any;
  props: React.HTMLAttributes<HTMLLIElement>;
}

const SuggestionItem = ({ option, props }: Props) => {
  if (!option?.data) {
    return null;
  }
  const { value, data } = option;
  const { inn, ogrn, management, address } = data;
  return (
    <li {...props}>
      <div className={styles.wrapper}>
        <div>{value}</div>
        {inn && <div>ИНН {inn}</div>}
        {ogrn && <div>ОГРН {ogrn}</div>}
        {management?.name && (
          <div>
            {management?.post} {management?.name}
          </div>
        )}
        {address?.value && <div>{address?.value}</div>}
      </div>
    </li>
  );
};

export default SuggestionItem;
